import Page from "webPage/Page";

import Track from "util/Track";

Page.register('blog', () => {
    $('.js-news-cards-wrap').each(function() {
        new Track($(this), {
            classes: {
                block: "news-cards-wrap",
            },
        });
    });

    new Track($('.js-card-slider-wrap'), {
        classes: {
            block: "card-slider",
        },
    });
});
